import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface RefreshState {
  mailThreadRefresh: boolean;
  rejectedCandidate: number[] | null;
  searchResultRefresh: boolean;
  HRFlowProjectRefresh: boolean;
  creditsRefresh: number | null;
  candidateProfile: boolean;
  questiontemplateList: boolean;
  searchInitiate: number | null;
  searchCancel: number | null;
  emailTemplateRefresh: boolean;
  criteriaTemplateList: boolean;
}

const initialState: RefreshState = {
  mailThreadRefresh: false,
  rejectedCandidate: null,
  searchResultRefresh: false,
  creditsRefresh: null,
  candidateProfile: false,
  HRFlowProjectRefresh: false,
  questiontemplateList: false,
  searchInitiate: null,
  searchCancel: null,
  emailTemplateRefresh: false,
  criteriaTemplateList: false,

};

const refreshSlice = createSlice({
  name: 'refresh',
  initialState: initialState,
  reducers: {
    mailThreadChange: (state) => {
      state.mailThreadRefresh = !state.mailThreadRefresh;
    },
    emailTemplateChange: (state) => {
      state.emailTemplateRefresh = !state.emailTemplateRefresh;
    },
    candidateCriteriaTemplateChange: (state) => {
      state.criteriaTemplateList = !state.criteriaTemplateList;
    },
    setRejectedCandidate: (state, action: PayloadAction<number[]>) => {
      state.rejectedCandidate = action.payload;
    },
    searchFilterChange: (state) => {
      state.searchResultRefresh = !state.searchResultRefresh;
    },
    refreshProjectChange: (state) => {
      state.HRFlowProjectRefresh = !state.HRFlowProjectRefresh;
    },
    candidateProfileRefresh: (state) => {
      state.candidateProfile = !state.candidateProfile;
    },
    creditsRefreshChanger: (state) => {
      if (state.creditsRefresh != null) {
        state.creditsRefresh = state.creditsRefresh + 1;
      } else {
        state.creditsRefresh = 0;
      }
    },
    questiontemplateListRefresh: (state) => {
      state.questiontemplateList = !state.questiontemplateList;
    },
    changeSearchInitiate: (state) => {
      if (state.searchInitiate != null) {
        state.searchInitiate = state.searchInitiate + 1;
      } else {
        state.searchInitiate = 0;
      }
    },
  },
});

export const {
  mailThreadChange,
  candidateCriteriaTemplateChange,
  emailTemplateChange,
  searchFilterChange,
  refreshProjectChange,
  candidateProfileRefresh,
  questiontemplateListRefresh,
  changeSearchInitiate,
  creditsRefreshChanger,
  setRejectedCandidate
} = refreshSlice.actions;

export default refreshSlice.reducer;
